import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Select } from "antd";
import { API_URLS } from "../../../api/apiUrls";
import { postApi, getApi } from "../../../api/api_instance";
// import { toast } from "react-hot-toast";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";

const FilterDialog = ({ onOpen, onClose, onFilterChange, setRole, role }) => {

  const [roleOptions, setRoleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ role: "" });

  const fetchRoles = async () => {
    try {
      const response = await getApi({ apiUrl: API_URLS.ALL_ROLES });

      if (response.success && response.data?.docs?.length > 0) {
        const formattedRoles = response.data.docs.map((role) => ({
          label: role.Role,
          value: role._id,
        }));
        setRoleOptions(formattedRoles);
      } else {
        console.error("Failed to fetch roles.");
      }
    } catch (error) {
      console.error("Error fetching roles.");
    }
  };

  const handleSave = async () => {

    let isValid = true;
    const errors = { role: "" };

    if (!role) {
      errors.role = "Role is required.";
      isValid = false;
    }


    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    // try {
    //   const response = await postApi({
    //     apiUrl: API_URLS.User,
    //     data: { role }
    //   });

    //   if (response.success) {
    //     toast.success("User created successfully!");
    //     onClose();
    //   } else {
    //     toast.error(response.message || "Failed to create user.");
    //   }
    // } catch (error) {
    //   toast.error(error.response?.data?.message || "Something went wrong.");
    // } finally {
    //   setLoading(false);
    // }
    onFilterChange({ role: role.name });
    onClose();
  };

  const handleCancel = () => {
    setErrorMessage({});
    setRole(null);
    onFilterChange({});
    onClose();
  };

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
      <div>
        <h3 className="text-xl font-bold text-[#06513D]">Filter</h3>
      </div>

      <div className="rounded-xl border mt-8 px-12 py-12">
        <div className="flex flex-col gap-6">
          <Select
            placeholder="Select Role"
            options={roleOptions}
            value={role ? { label: role.name, value: role.id } : null}
            labelInValue
            onChange={(value, option) => {
              setRole({
                id: value,
                name: option.label,
              });
            }}
            onFocus={fetchRoles}
            style={{ height: 40 }}
          />

          {errorMessage.role && (
            <div className="text-red-500 text-sm">{errorMessage.role}</div>
          )}
        </div>
      </div>

      <div className="flex justify-center gap-6 p-5">
        <CustomButton
          buttonType="button"
          variant="cancel"
          buttonText="Cancel"
          onClick={handleCancel}
          className="text-base font-normal h-[50px] w-[160px]"
        />

        <CustomButton
          buttonType="button"
          variant="ok"
          buttonText="Save"
          onClick={handleSave}
          disabled={loading}
          className="text-base font-normal h-[50px] w-[160px]"
        />
      </div>
    </DailogBox>
  );
};

export default FilterDialog;
